import { IconLoading } from '@/icons';
import { T } from '@/ui/Text/Text';
import { Button } from '@/ui/Button/Button';
import { useNavigate } from 'react-router-dom';
import { Flex } from '@/ui/Flex/Flex';
import { envIsElectron } from 'src/const/envCheck';
import { StyledLoadingContentBox, StyledLoadingWrapper } from './styles';

interface SlideRendererLoaderProps {
  testId: string;
  completedItems: number;
  totalItems: number;
  isLoadingUnitContent: boolean;
}
const SlideRendererLoader = ({
  testId,
  completedItems,
  totalItems,
  isLoadingUnitContent,
}: SlideRendererLoaderProps) => {
  const navigate = useNavigate();
  return (
    <StyledLoadingWrapper data-testid={testId}>
      <StyledLoadingContentBox
        justify="space-between"
        align="center"
        direction="column"
      >
        <T h1>
          Starting your
          <br />
          Experience
        </T>
        <Flex padding="32px 32px">
          <IconLoading />
        </Flex>
        <T p>
          {isLoadingUnitContent
            ? 'fetching your content...'
            : `${completedItems}/${totalItems} items completed`}
        </T>
        <br />
        <div style={{ alignSelf: 'flex-start' }}>
          <Button
            mode="transparent"
            onClick={() => {
              if (envIsElectron) {
                window.electron.ipcRenderer.sendMessage('shutdownPlayer');
              }
              navigate('/');
            }}
          >
            <T link>Abort</T>
          </Button>
        </div>
      </StyledLoadingContentBox>
    </StyledLoadingWrapper>
  );
};

export { SlideRendererLoader };
